import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import { jsx } from '@emotion/react';

const ThemedInteractiveList = /*#__PURE__*/themed("ul", process.env.NODE_ENV === "production" ? {
  target: "e1kyujov0"
} : {
  target: "e1kyujov0",
  label: "ThemedInteractiveList"
})(() => ({
  boxSizing: "border-box",
  fontFamily: "default",
  lineHeight: "normal",
  isolation: "isolate",
  margin: 0,
  padding: 0,
  textIndent: 0,
  listStyleType: "none"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkludGVyYWN0aXZlTGlzdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSThCIiwiZmlsZSI6IkludGVyYWN0aXZlTGlzdC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiB9IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IHsgdGhlbWVkIH0gZnJvbSBcIkBpbmRlZWQvaWZsLWNzc1wiO1xuaW1wb3J0IHsgSW50ZXJhY3RpdmVMaXN0UHJvcHMgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5jb25zdCBUaGVtZWRJbnRlcmFjdGl2ZUxpc3QgPSB0aGVtZWQoXCJ1bFwiKTxJbnRlcmFjdGl2ZUxpc3RQcm9wcz4oKCkgPT4gKHtcbiAgYm94U2l6aW5nOiBcImJvcmRlci1ib3hcIixcbiAgZm9udEZhbWlseTogXCJkZWZhdWx0XCIsXG4gIGxpbmVIZWlnaHQ6IFwibm9ybWFsXCIsXG4gIGlzb2xhdGlvbjogXCJpc29sYXRlXCIsXG4gIG1hcmdpbjogMCxcbiAgcGFkZGluZzogMCxcbiAgdGV4dEluZGVudDogMCxcbiAgbGlzdFN0eWxlVHlwZTogXCJub25lXCJcbn0pKTtcblxuLyoqXG4gKiBAc2VlIGh0dHBzOi8vZXhwZXJpZW5jZS5pbmRlZWQuZGVzaWduL2NvbXBvbmVudHMvaWRzL2ludGVyYWN0aXZlLWxpc3RcbiAqL1xuZXhwb3J0IGNvbnN0IEludGVyYWN0aXZlTGlzdCA9IGZvcndhcmRSZWY8XG4gIEhUTUxVTGlzdEVsZW1lbnQsXG4gIEludGVyYWN0aXZlTGlzdFByb3BzXG4+KChwcm9wcywgcmVmKSA9PiB7XG4gIGNvbnN0IHsgY2hpbGRyZW4sIC4uLnJlbWFpbmluZ1Byb3BzIH0gPSBwcm9wcztcblxuICByZXR1cm4gKFxuICAgIDxUaGVtZWRJbnRlcmFjdGl2ZUxpc3QgcmVmPXtyZWZ9IHsuLi5yZW1haW5pbmdQcm9wc30+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9UaGVtZWRJbnRlcmFjdGl2ZUxpc3Q+XG4gICk7XG59KTtcblxuSW50ZXJhY3RpdmVMaXN0LmRpc3BsYXlOYW1lID0gXCJJbnRlcmFjdGl2ZUxpc3RcIjtcbiJdfQ== */");

/**
 * @see https://experience.indeed.design/components/ids/interactive-list
 */
const InteractiveList = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    ...remainingProps
  } = props;
  return jsx(ThemedInteractiveList, _extends({
    ref: ref
  }, remainingProps), children);
});
InteractiveList.displayName = "InteractiveList";

export { InteractiveList };
